import { render } from "./CompanyReport.vue?vue&type=template&id=884cc062&scoped=true"
import script from "./CompanyReport.vue?vue&type=script&lang=js"
export * from "./CompanyReport.vue?vue&type=script&lang=js"

import "./CompanyReport.vue?vue&type=style&index=0&id=884cc062&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-884cc062"]])

export default __exports__